
import throttle from './../helpers/throttle.js';

// cache selector vars

const $window = $(window);
let $igsRows = false;
let runOnce = false;


function isInViewport(node) {
	var rect = node.getBoundingClientRect();
	return (
		(rect.height > 0 || rect.width > 0) &&
		rect.bottom >= 0 &&
		rect.right >= 0 &&
		rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
		rect.left <= (window.innerWidth || document.documentElement.clientWidth)
	)
};


function scrollHandler() {

	// don't run if there aren't any rows
	if (!$igsRows || !$igsRows.length) return false;

	var scrolled = $(window).scrollTop();

	$igsRows.each(function(index, element) {
		var
		initY = $(this).offset().top,
		height = $(this).height(),
		endY  = (initY + $(this).height()),
		visible = isInViewport(this);

		if(visible) {
			var
			ratio = $(this).data("scroll-ratio"),
			scrollTop = $(window).scrollTop(),
			elementOffset = $(this).offset().top,
			distance = (1 - (elementOffset - scrollTop - $(window).height()));

			// only do this if the window is above size S.
			if(sizeS) {
				$(this).css('transform', 'translateX(' + - distance * ratio + 'px)');
			}
			else {
				$(this).css('transform', 'translateX(0px)');
			}
		};
	});
}


function init() {
	const scrollHandlerThrottled = throttle(scrollHandler, 13);
	$window.scroll(scrollHandlerThrottled);
}


function dateToString(date) {
	var months = [
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
		'August',
		'September',
		'October',
		'November',
		'December'
	];
	var _date = new Date(date.split(' ')[0]);
	return `${_date.getDate()} ${months[_date.getMonth()]}`;
}


export default function(options) {

	var
	settings = $.extend({
		id: 'id',
		key: '6038e85e-3df6-409a-a309-241bcb6bcd99'
	}, options);

	// arrow func: needs to be bound to jQuery object
	const render = () => {
		// only run render once
		if (runOnce) return;
		runOnce = true;
		
		this.each(function() {

			var
			rows = [
				$('<div class="igs-row" data-scroll-ratio="-0.05"/>'),
				$('<div class="igs-row" data-scroll-ratio="0.05"/>')
			],
			row = 0,
			count = 0,
			max = 12;

			$(this).append(rows[0]);
			$(this).append(rows[1]);

			$.ajax({
				url: `https://api.curator.io/v1/feeds/${settings.id}/posts`,
				data: {
					api_key: settings.key
				},
				success: function(json) {

					json.posts.forEach(function(post) {

						if(count<max&&post.has_image) {
							rows[row].append(`<a target="_blank" href="${post.url}" class="igs-block has-igs-overlay"><img src="${post.image}"> <div class="igs-overlay">${dateToString(post.source_created_at)}</div></a>`);
							count ++;
							row = row===0?1:0;
						};
					});

					// set global $igsRows for scrollHandler
					$igsRows = $('.igs-row');
					init();
				}
			});
		});		
	}

	this.lazyLoadOnScroll({
		handler : function() {
			render();
		},
		threshold : -1000 - $window.height()
	});
};
